import { LevelProps } from '../../../Types'
import { LEVEL_CARDS } from '../../../Constants'
import { LevelPage } from '../../LevelPage'

export const TurnInto = (props: LevelProps) => {
  return <LevelPage {...props} imgScale={0.4} textWidth="50%" cards={LEVEL_CARDS.L3.TURN_INTO} />
}
